import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    wrapper: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
      marginTop: 88,
      marginLeft: -24,
    },
    container: {
      backgroundColor: theme.form.background,
      padding: constants.divPadding,
      borderRadius: constants.radius.card,
      maxWidth: 500,
      marginLeft: constants.divPadding,
      marginRight: constants.divPadding,
    },
    text: {
      textAlign: "center",
    },
    footer: {
      justifyContent: "space-around",
    },
    footerInner: {
      justifyContent: "center",
      display: "flex",
      alignItems: "center",
    },
    store: {
      cursor: "pointer",
    },
    qr: {
      display: "flex",
      justifyContent: "center",
    },
  };

  return styles;
};
